import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const InputSection = ({
  className,
  placeholder,
  label,
  name,
  value,
  error,
  onChange,
}) => (
  <div className={`col-xs-12  padding-top-1 ${className}`}>
    <>
      <strong htmlFor={name}>{label}</strong>
      <input
        type="password"
        className="texto-gris form-control"
        onChange={onChange}
        id={name}
        name={name}
        value={value}
        error={error}
        placeholder={placeholder}
      />
      {error && (
        <>
          <span className="input-group-addon error-icon">
            <i className="fa fa-exclamation-triangle" />
          </span>
          <span className="help-block error-wrapper error-invalid">
            {error}
          </span>
        </>
      )}
    </>
  </div>
);

InputSection.propTypes = {
  className: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  error: PropTypes.string,
  onChange: PropTypes.func,
};

export default InputSection;
